<script setup lang="ts">

</script>

<template>
    <section>
        <slot />
    </section>
</template>


<style lang="scss" scoped>
section {
    padding: 40px 0;
    position: relative;

    &:after {
        content: '';
        position: absolute;
        left: 40px;
        bottom: 0;
        right: 40px;
        height: 1px;
        background: #fff;
    }

    :deep(h1) {
        padding: 0 20px;
        margin: 24px 0 48px 0;
        font-size: 36px;
        font-weight: 300;
    }

    :deep(h2) {
        margin: 0 0 32px 0;

        span {
            background: #fff;
            padding: 8px 20px;
            font-size: 18px;
        }
    }

    :deep(.text-block) {
        padding: 0 20px;
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 12px;
    }

    :deep(.section__graphic) {
        padding: 10px 20px 120px 20px;
        height: 500px;
    }

    &:first-child {
        padding-top: 0;
    }

    &:last-child {

        .section__graphic {
            padding-bottom: 0;
        }
    }
}
</style>
